import React from 'react';
import { environments } from 'environments/environments';
// import { byDateParts } from 'libs/functions/order';
import { Event } from '../Event.interface';
import EventPreview from '../EventPreview/EventPreview';
import { Link } from 'react-router-dom';
import './PastEvents.css'


interface Props { preview: boolean }
interface State { events: Event[], loading: boolean, error: boolean }

export default class PastEvents extends React.Component<Props, State> {
  state = {
    events: [] as Event[],
    loading: false,
    error: false
  }

  mounted = false;
  controller = new AbortController();

  componentDidMount() {
    this.mounted = true;
    this.getEventsFromDB();
  }

  componentWillUnmount() {
    this.mounted = false;
    this.controller.abort();
  }

  /** Reaches server to get list of all events and set it to state. */
  getEventsFromDB() {
    this.setState({ events: [], loading: true, error: false });
    const count = this.props.preview ? 3 : 0;
    const params = `?t=events&count=${count}&order=eventtime&c=eventtime<${Date.now()}`;
    fetch(environments.server + environments.backend + params, { signal: this.controller.signal }).then(
      async (result: any) => {
        const dbEvents = await result.json();
        // console.log(dbEvents);
        if (dbEvents && dbEvents.length) {
          const events: Event[] = dbEvents.map((event: any) => {
            const guests = (event.guests || '').replace(/&quot;/g, '"').replace(/&apos;/g, '\'').split(';');
            const modifiedEvent: Event = { ...event, guests };
            return modifiedEvent;
          });
          this.setState({ events: events, loading: false, error: false });
        }
      }
    ).catch(e => {
      if (this.mounted) {
        this.setState({ events: [], error: true, loading: false })
      }
    });
  }

  render() {
    let year = new Date().getFullYear();
    let eventsAndDividers: Event[] = [];
    if (this.props.preview) {
      eventsAndDividers = [...this.state.events];
    } else {
      this.state.events.forEach((event: Event) => {
        if (+event.year !== year) {
          year = +event.year;
          eventsAndDividers.push({ year } as Event);
        }
        eventsAndDividers.push(event);
      });
    }
    const renderEvents = eventsAndDividers.map((event, index) => {
      if (event.id) {
        return <EventPreview key={index} event={event} past={true} />
      }
      return <p key={event.year} className="event-year-divider">{event.year}</p>
    });

    return (
      <div className="section">
        {this.props.preview
          ? null
          : <Link to="/akce" className="event-link-back">&larr; Zpět na akce</Link>
        }
        {this.state.loading
          ? <p className='loading-info'><span className="loading loading-spinner"></span> Načítá se seznam minulých akcí...</p>
          : this.state.error
            ? <p className='loading-error'>
              Nepovedlo se načíst seznam minulých akcí, zkusit <span onClick={() => this.getEventsFromDB()}>ZNOVU</span>?
            </p>
            : renderEvents
        }
      </div>
    );
  }
}